var _debounce			= require('lodash.debounce');
var bindEvent			= require('../eventHandlers/bindEvent');
var slickVideo 			= require('slickVideo');

function slicks() {

	var $newsesSmallSlider = document.querySelector('.newses-small-slider'),
		$siteSlider = $('.image-slider'),
		$imageHldSlider = document.querySelector('.image-hld-sec--slider'),
		$galleryLanding = document.querySelector('.section--gallery-landing');

	function slickDotsPos() {

		if(document.querySelector('.slick-dots')){

			var $bannerText = document.querySelector('.photo-slider__content-container'),
				$bannerDots = document.querySelector('.slick-dots'),
				$posBannerTextLeft = $bannerText.offsetLeft + 40,
				$posBannerTextTop = $bannerText.offsetHeight + $bannerText.offsetHeight + 20;

			$bannerDots.style.top = $posBannerTextTop + 'px';
			$bannerDots.style.left = $posBannerTextLeft + 'px';

		}

	}

	if($siteSlider) {

		$siteSlider.slick({
			dots: true,
			infinite: true,
			speed: 2000,
			autoplay: true,
  			autoplaySpeed: 4000,
  			pauseOnHover: false,
			slidesToShow: 1,
			prevArrow: '<span class="slick-prev"></span>',
			nextArrow: '<span class="slick-next"></span>'
		});
		
	}

	if( !$('#photo-slider').is('slick-initialized') ) {

		var $sliderVideo = document.querySelector('.photo-slider--video');

		if($sliderVideo) {

			var vSlickData = {
			    videoTested: false,
			    videoAllow: false,
			    videoBuffering: false
			}

			$sliderVideo = new slickVideo({
				vslides: '.photo-slider--video',
				slick_slide: '.photo-slider__item',
				slick_img    : false,
				video_js  : '.video-js',
				slick_autoplaySpeed: 5000, //czas wyswietlania
				slick_speed: 3500, //czas przejscia
				testingTime: 1500, //czas testowania pierwszego video
				vertical: true,
				video_muted: true,
				dots: true,
				draggable: true,
				autoplay: true
			});

			slickDotsPos();

			bindEvent(window, 'resize', _debounce(slickDotsPos, 250));

		}

		$('.photo-slider--subpage').slick({
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			cssEase: 'cubic-bezier(0.75,0.25,0.25,1)',
			dots: true,
			arrows: false,
			appendDots: document.querySelector('.photo-slider_dots-hld'),
			fade: true
		});

	}

	if( $newsesSmallSlider && !$('.newses-small-slider .news-listing').is('slick-initialized') ) {

		$('.newses-small-slider .news-listing').slick({
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			cssEase: 'cubic-bezier(0.75,0.25,0.25,1)',
			dots: true,
			arrows: false,
			appendDots: document.querySelector('.newses-small-slider__dots-hld'),
			fade: true
		});

	}

	$('.home-offer-slider').slick({
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		autoplay: false,
		autoplaySpeed: 4000,
		cssEase: 'cubic-bezier(0.75,0.25,0.25,1)',
		dots: false,
		arrows: true,
		prevArrow: '<span class="slick-prev"></span>',
		nextArrow: '<span class="slick-next"></span>'
	});

	if($imageHldSlider) {

		$('.image-hld-sec--slider').slick({
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			autoplay: false,
			cssEase: 'cubic-bezier(0.75,0.25,0.25,1)',
			dots: false,
			arrows: true,
			prevArrow: '<span class="slick-prev"></span>',
			nextArrow: '<span class="slick-next"></span>'
		});

	}

	if($galleryLanding) {

		var $galleryThumbsItem = document.querySelectorAll('.gallery-landing-thumbs-item'), 
			$galleryThumbsItemOne = $('.gallery-landing-thumbs-item');

		$('.gallery-landing-big').slick({
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			cssEase: 'cubic-bezier(0.75,0.25,0.25,1)',
			dots: false,
			arrows: true,
			fade: true,
			prevArrow: '<span class="slick-prev ssn-bg"></span>',
			nextArrow: '<span class="slick-next ssn-bg"></span>'
		});

		$('.gallery-landing-thumbs').slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			asNavFor: '.gallery-landing-big',
			focusOnSelect: true,
			variableWidth: true,
			prevArrow: '<span class="slick-prev ssn-bg"></span>',
			nextArrow: '<span class="slick-next ssn-bg"></span>',
			responsive: [{
			    breakpoint: 1280,
			    settings: {
			    	slidesToShow: 3
			    }
			}, 
			{
			    breakpoint: 768,
			    settings: {
			    	slidesToShow: 2
			    }
			},
			{
			    breakpoint: 480,
			    settings: {
			        slidesToShow: 1
			    }
			}]

		});

		$('.gallery-landing-big').on('afterChange', function(event, slick, currentSlide, nextSlide){

			for (var i = 0; i < $galleryThumbsItem.length; i++) {
				$galleryThumbsItem[i].classList.remove('active');
			}

	    	$('.gallery-landing-thumbs-item').each(function(){
		    	if(this.getAttribute('data-slick-index') == currentSlide && !this.classList.contains('slick-cloned') ) {
		    		this.classList.add('active');
		    	}
	    	});
		});


		if($galleryThumbsItem) {
			$galleryThumbsItemOne.eq(0).addClass('active');
		}


	}
	
};

module.exports = slicks;